import React from 'react';

const ThinkingIndicator: React.FC = () => {
  return (
    <div className="flex justify-start">
      <div className="max-w-[85%] rounded-lg p-4 bg-slate-700 text-slate-100 shadow-lg">
        <div className="flex items-center gap-2">
          <div className="text-slate-300">Thinking</div>
          <div className="flex gap-1">
            {[0, 1, 2].map((i) => (
              <div
                key={i}
                className="w-1.5 h-1.5 bg-slate-300 rounded-full animate-bounce"
                style={{
                  animationDelay: `${i * 0.2}s`,
                  animationDuration: '1s'
                }}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThinkingIndicator;
